import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createBlock(_component_v_data_table, {
    class: "elevation-1 pre-wrap",
    headers: _ctx.headers,
    items: _ctx.templateVariables,
    "items-per-page": -1,
    density: "compact",
    "item-value": "variable"
  }, {
    [`item.value`]: _withCtx(({ item }) => [
      _createElementVNode("span", null, _toDisplayString(item.value.toString()), 1)
    ]),
    [`item.variable`]: _withCtx(({ item }) => [
      _createElementVNode("span", null, _toDisplayString(item.variable), 1)
    ]),
    [`item.actions`]: _withCtx(({ item }) => [
      _createVNode(_component_v_tooltip, { location: "left" }, {
        activator: _withCtx(({ props }) => [
          _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
            _createVNode(_component_v_btn, {
              onClick: ($event: any) => (_ctx.doInsert(item.variable)),
              class: "ma-1",
              density: "comfortable",
              size: "small",
              icon: "mdi-share",
              color: "info"
            }, null, 8, ["onClick"])
          ], 16)
        ]),
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "Insert the variable at the caret position.", -1))
        ]),
        _: 2
      }, 1024),
      _createVNode(_component_v_tooltip, { location: "right" }, {
        activator: _withCtx(({ props }) => [
          _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
            _createVNode(_component_v_btn, {
              onClick: ($event: any) => (_ctx.doCopy(item.variable)),
              class: "ma-1",
              density: "comfortable",
              size: "small",
              icon: "mdi-content-copy",
              color: "info"
            }, null, 8, ["onClick"])
          ], 16)
        ]),
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("span", null, "Copy the variable to the system clipboard.", -1))
        ]),
        _: 2
      }, 1024)
    ]),
    _: 2
  }, 1032, ["headers", "items"]))
}